import {  PRODUCT_DETAIL_NOTIFICATION_SET_MESSAGE } from '../constants';

export const setMessage = (data) => ({
    type: PRODUCT_DETAIL_NOTIFICATION_SET_MESSAGE,
    payload: {
        message: data.message,
        type: data.type
    },
});

export const setInfoMessage = (data) => ({
    type: PRODUCT_DETAIL_NOTIFICATION_SET_MESSAGE,
    payload: {
        message: data.message,
        type: 'info'
    },
});

export const setErrorMessage = (message) => ({
    type: PRODUCT_DETAIL_NOTIFICATION_SET_MESSAGE,
    payload: {
        message: message,
        type: 'error'
    },
});

export const clearErrorMessage = () => ({
    type: PRODUCT_DETAIL_NOTIFICATION_SET_MESSAGE,
    payload: {
        message: '',
        type: ''
    },
});
